import { skipOnboarding } from '@api/onboarding/onboarding.service';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@shared/hooks';
import { toast } from '@ui/components';

export const useSkipOnboarding = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { user } = useCurrentUser();
  const companyId = user?.companies[0]?.id ?? '';

  const { mutate: skipOnboardingMutation, isPending: isSkippingOnboarding } = useMutation({
    mutationFn: () => skipOnboarding(),
    onSuccess: () => {
      navigate(`/${companyId}`, { replace: true });
    },
    onError: () => {
      toast.error(t('API_ERRORS.DEFAULT'));
    },
  });

  return {
    skipOnboardingMutation,
    skipOnboarding,
    isSkippingOnboarding,
  };
};
